import { createFileRoute, redirect } from "@tanstack/react-router";

import { getAccessToken } from "../auth";
import { CustomerPortalPage } from "../pages/customer-portal-page";
import { requireCustomerSession } from "../route-authorization";

export const Route = createFileRoute("/customer")({
  beforeLoad: () => {
    if (!getAccessToken()) throw redirect({ to: "/login", search: { activated: false } });
    return requireCustomerSession();
  },
  component: CustomerPortalPage,
});
